import { LineStyle } from './shapes/abstract/AbstractSheetLineShape';
import { ChakraColor } from 'src/utils/color-util';

export const AUTODESK_VIEWING_INITIALIZER_ENV = 'AutodeskProduction2';
export const AUTODESK_VIEWING_INITIALIZER_API = 'streamingV2_EU';
export const VIEWER_TOP_OFFSET = 68;

export const CALIBRATION_TOOL_SNAPPING_ANGLE_STEP = 45; // snap to n degrees while pressing shift key
export const CALIBRATION_TOOL_OVERLAY_ID = 'EDIT2D_CALIBRATION_TOOL_OVERLAY';
export const MEASUREMENT_TOOL_SNAPPING_ANGLE_STEP = 45; // snap to n degrees while pressing shift key
export const MEASUREMENT_TOOL_OVERLAY_ID = 'EDIT2D_MEASUREMENT_TOOL_OVERLAY';
export const CROSSHAIR_CURSOR = 'crosshair';
export const POINTER_CURSOR = 'pointer';
export const MOVE_CURSOR = 'move';
export const WAIT_CURSOR = 'wait';

// DPI used for mapping points in a PDF to the system's coordinate system,
// following the PDF.js methodology (conversion consistent with the existing coordinate storage format)
export const PDF_COORDINATE_MAPPING_DPI = 72;
export const INCHES_IN_ONE_METER = 39.3701;

export const ENABLE_APS_SHEET_VIEWER_FLAG = 'enable-aps-sheet-viewer';

export const DefaultShapeStyle = {
  lineWidth: 0.5,
  fillAlpha: 0.7,
  lineColor: ChakraColor.gray800,
  fillColor: ChakraColor.gray500,
  lineStyle: LineStyle.Solid,
};
export const HoveredShapeStyle = {
  lineWidth: 0.5,
  fillAlpha: 0.7,
  lineColor: ChakraColor.gray800,
  fillColor: ChakraColor.gray500,
  lineStyle: LineStyle.Solid,
};
export const SelectedShapeStyle = {
  lineWidth: 0.5,
  fillAlpha: 0.8,
  lineColor: ChakraColor.blue100,
  fillColor: ChakraColor.blue300,
  lineStyle: LineStyle.Solid,
};

export const DefaultLineStyle = {
  lineWidth: 5,
  lineColor: ChakraColor.gray500,
  lineStyle: LineStyle.Solid,
};
export const HoveredLineStyle = {
  lineWidth: 5,
  lineColor: ChakraColor.gray500,
  lineStyle: LineStyle.Solid,
};
export const SelectedLineStyle = {
  lineWidth: 6,
  lineColor: ChakraColor.blue300,
  lineStyle: LineStyle.Solid,
};

export const CalibrationDefaultLineStyle = {
  lineWidth: 0.05,
  lineColor: ChakraColor.yellow500,
};
export const CalibrationDrawingLineStyle = {
  lineWidth: 0.05,
  lineColor: ChakraColor.yellow300,
};

export const HoveredInvalidLineStyle = {
  lineWidth: 2,
  lineColor: ChakraColor.orange200,
  lineStyle: LineStyle.Solid,
};

export const HoveredValidLineStyle = {
  lineWidth: 2,
  lineColor: ChakraColor.green200,
  lineStyle: LineStyle.Solid,
};

export const InvalidShapeStyle = {
  lineWidth: 2,
  fillAlpha: 0.3,
  lineColor: ChakraColor.orange400,
  fillColor: ChakraColor.orange200,
  lineStyle: LineStyle.Solid,
};

export const ValidShapeStyle = {
  lineWidth: 2,
  fillAlpha: 0.3,
  lineColor: ChakraColor.green400,
  fillColor: ChakraColor.green200,
  lineStyle: LineStyle.Solid,
};

export const InvalidLineStyle = {
  lineWidth: 2,
  lineColor: ChakraColor.orange400,
  lineStyle: LineStyle.Solid,
};

export const ValidLineStyle = {
  lineWidth: 2,
  lineColor: ChakraColor.green400,
  lineStyle: LineStyle.Solid,
};

export const VertexStyle = {
  lineWidth: 1,
  fillAlpha: 1,
  lineColor: ChakraColor.blue300,
  fillColor: ChakraColor.gray50,
};

export const FirstVertexStyle = {
  lineWidth: 1,
  fillAlpha: 1,
  lineColor: ChakraColor.gray50,
  fillColor: ChakraColor.blue300,
};

// Snapping indicator style - shown when cursor is near a snap point
export const SnappingIndicatorStyle = {
  size: 12, // px
  borderWidth: 2,
  borderColor: ChakraColor.orange400,
  backgroundColor: 'transparent',
};
